export default {
  AD_PRODUCTS: "adProducts",
  CONTENT_TAG: "contentTag",
  CONTENT_TAG_LIST: "contentTagList",
  VIDEO_DETAILS: "videoDetails",
  GAME_DETAILS: "gameDetails",
  GAME_STATE: "gameState",
  CONTENT_TAG_PRINTABLE_LIST: "contentTagPrintableList",
  CONTENT_TAG_VIDEO_LIST: "contentTagVideoList",
  CONTENT_TAG_BLOG_LIST: "contentTagBlogList",
  CONTENT_TAG_GAME_LIST: "contentTagGameList",
  PRINTABLE_DETAILS: "printableDetails",
  RECENTLY_PUBLISHED_VIDEOS: "recentlyPublishedVideos",
  HERO_VIDEO: "heroVideo",
  HERO_UNIT: "heroUnit",
  NEWEST_PRINTABLES: "newestPrintables",
  USER: "user",
  FEATURED_CONTENT: "featuredContent",
  SEARCH_FILTERS: "searchFilters",
  AD_PRODUCT_PRE_ROLL_SLATE: "adProductPreRollSlate",
  SHELVES: "shelf",
  GRADES: "grades",
  SCHOOLS: "schools",
  LOGIN: "login",
  FAVORITES: "favorites",
  CHAMPS: "champs",
  PROFILE_CHAMPS: "profileChamps",
  AGE_GROUPS: "ageGroups",
  CURRICULUM: "curriculum",
  COMPETENCY: "competency",
  ELEMENT: "element",
  LAYOUT: "layout",
  ON_SITE_MESSAGES: "onSiteMessages",
};
